// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Vant from 'vant'
import store from './store'
import 'vant/lib/index.css' //引入vant样式
import "@/styles/common.css" //引入公共样式
import global from "@/api/common" ;
import commonHeader from "@/components/common-header";  //全局引入公共组件
import '@vant/touch-emulator';
Vue.component("commonHeader", commonHeader);
Vue.config.productionTip = false ;
Vue.use(Vant);
Vue.prototype.GLOBAL = global ; //设置接口路径
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js